import { forwardRef, useId } from 'react';
import { Loader } from 'modules/v2/feedback/Loader';
import { MenuInput } from './MenuInput';
import { SearchContainer, SearchContainerInput, SearchContainerIcon } from './styled';
export const MenuHeaderInput = forwardRef((props, ref) => {
    const { id, icon, value, placeholder, loading, disabled, actions, autoFocus = true, type = 'text', onChange } = props;
    const generatedId = useId();
    const inputId = id || generatedId;
    const inputDisabled = loading || disabled;
    const handleChange = (event) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(event.currentTarget.value);
    };
    return (<SearchContainer $sticky data-id="menu-header-sticky">
      {icon && <SearchContainerIcon>{icon}</SearchContainerIcon>}
      <MenuInput render={<SearchContainerInput ref={ref} id={inputId} value={value} placeholder={placeholder} disabled={inputDisabled} autoFocus={autoFocus} type={type} onChange={handleChange}/>}/>
      {loading && (<SearchContainerIcon>
          <Loader size="xs"/>
        </SearchContainerIcon>)}
      {!loading && <SearchContainerIcon>{actions}</SearchContainerIcon>}
    </SearchContainer>);
});
